/**
 * 관리자 홈 Container
 * --
 */
import React from 'react';
// import MainHomePresenter from './MainHomePresenter';
import ProductDashboard from 'routes/admin.routes/admin.dashboard/ProductDashboard';
import { useUserStack } from 'store';

const MainHomeContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <ProductDashboard
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
          shopType={'SHOP'}
        />
      )}
    </>
  );
};

export default MainHomeContainer;
